import Dropdown from './NavbarNotificationsDropdown';
import Translations from '../../utils/Translations';
import Flux from '../../flux/Flux';
import { onClick } from './NavbarHelper';
import { Component } from 'react';

class NavbarNotifications extends Component {
	static markAllNotificationsAsSeen(e) {
		onClick(e);
		//setTimeout due to interesting behavior when toggling the parent's li class
		setTimeout(Flux.Notification.markAllNavbarNotificationsAsSeen, 0);
	}

	static markNotificationAsRead(id) {
		Flux.Notification.markNavbarNotificationAsRead(id);
	}

	static markAllNotificationsAsRead() {
		Flux.Notification.markAllNavbarNotificationsAsRead();
	}

	constructor(props) {
		super(props);

		this.state = {
			notifications: [],
		};

		this.onStoreChange = this.onStoreChange.bind(this);
	}

	componentDidMount() {
		Flux.Notification.addNavbarNotificationsChangeListener(this.onStoreChange);
	}

	componentWillUnmount() {
		Flux.Notification.removeNavbarNotificationsChangeListener(this.onStoreChange);
	}

	onStoreChange() {
		this.setState({
			notifications: Flux.Notification.getNavbarNotifications(),
		});
	}

	render() {
		// create unread item count label
		let badge;
		let unseenCount = 0;
		for (let i = 0; i < this.state.notifications.length; i++) {
			if (this.state.notifications[i].unseen) {
				unseenCount++;
			}
		}
		if (unseenCount > 0) {
			badge = <span className="badge--number animated--jump">{unseenCount}</span>;
		}

		// Dropdown menu (don't render menu on server!)
		const dropdown = (
			<Dropdown
				notifications={this.state.notifications}
				markNotificationAsRead={NavbarNotifications.markNotificationAsRead}
				markAllNotificationsAsRead={NavbarNotifications.markAllNotificationsAsRead}
			/>
		);

		// add class name "open" to show menu for debugging
		return (
			<div className="navigation__link">
				<a
					href="#"
					id="notificationCount"
					data-toggle="dropdown"
					className="js-dropdown-toggle navigation__link"
					role="button"
					aria-haspopup="true"
					aria-expanded="false"
					data-tooltip-id="tooltip-bottom"
					data-tooltip-content={Translations.get('NavbarNotificationsTooltip')}
					onClick={NavbarNotifications.markAllNotificationsAsSeen}
				>
					<i className="navigation__icon -icon-bell-full" />
					<span className="navigation__label">{Translations.get('NavbarNotificationsLabel')}</span>
					{badge}
				</a>
				{dropdown}
			</div>
		);
	}
}

export default NavbarNotifications;
